const ACCESS_TOKEN_KEY = 'imobdesk_access_token';

let accessTokenCache: string | null = null;
let initialized = false;

function isSecureProdDomain(): boolean {
  if (typeof window === 'undefined') return false;
  return window.location.hostname.toLowerCase().endsWith('.imobdesk.com.br');
}

function canPersistAccessTokenInLocalStorage(): boolean {
  return !isSecureProdDomain();
}

function getLocalStorageValue(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function setLocalStorageValue(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    // no-op
  }
}

function removeLocalStorageValue(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {
    // no-op
  }
}

export async function initializeTokenStorage(): Promise<void> {
  if (initialized) return;
  if (canPersistAccessTokenInLocalStorage()) {
    accessTokenCache = getLocalStorageValue(ACCESS_TOKEN_KEY);
  } else {
    accessTokenCache = null;
    removeLocalStorageValue(ACCESS_TOKEN_KEY);
  }
  initialized = true;
}

void initializeTokenStorage();

export function saveAccessToken(token: string): void {
  accessTokenCache = token;
  initialized = true;
  if (canPersistAccessTokenInLocalStorage()) {
    setLocalStorageValue(ACCESS_TOKEN_KEY, token);
  } else {
    removeLocalStorageValue(ACCESS_TOKEN_KEY);
  }
}

export function getAccessToken(): string | null {
  if (accessTokenCache) {
    return accessTokenCache;
  }
  if (canPersistAccessTokenInLocalStorage()) {
    const stored = getLocalStorageValue(ACCESS_TOKEN_KEY);
    if (stored) {
      accessTokenCache = stored;
      return stored;
    }
  }
  return null;
}

export async function getAccessTokenAsync(): Promise<string | null> {
  await initializeTokenStorage();
  return getAccessToken();
}

export function clearAccessToken(): void {
  accessTokenCache = null;
  initialized = true;
  removeLocalStorageValue(ACCESS_TOKEN_KEY);
}
